(function($){
    function init_tab_dropdown(){

        $('.ff-dropdown .e-n-tabs').each(function () {
            const $tabsWrapper = $(this);

            if ($(this).find('.ff-tabs-select-wrap').length) return;

            const $tabButtons = $tabsWrapper.find('.e-n-tab-title');
            const $tabContents = $tabsWrapper.find('.e-n-tabs-content > [role="tabpanel"]');

            if (!$tabButtons.length) return;

            // Create select & wrapper
            const $wrapper = $('<div class="ff-tabs-select-wrap"></div>');
            const $select = $('<select class="ff-tabs-select"></select>');
            $wrapper.append($select);


            $tabButtons.each(function (index) {
                const $btn = $(this);
                const title = $btn.find('.e-n-tab-title-text').text().trim();
                const isActive = $btn.attr('aria-selected') === 'true';

                $select.append(
                    $('<option>', {
                        value: index,
                        text: title,
                        selected: isActive
                    })
                );
            });

            $tabsWrapper.prepend($wrapper);

            $tabContents.not('.e-active').hide();

            // Change handler
            $select.on('change', function () {
                const index = $(this).val();

                $tabButtons
                    .attr('aria-selected', 'false')
                    .removeClass('e-active')
                    .eq(index)
                    .attr('aria-selected', 'true')
                    .addClass('e-active');

                $tabContents
                    .removeClass('e-active')
                    .hide();

                $tabContents
                    .eq(index)
                    .addClass('e-active')
                    .fadeIn(250);
            });
        });

    }

    init_tab_dropdown(); // run script
})(jQuery);